/**
 * Default: Components / Shared > Form (modify Shared)
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {extend} from '@ifabnpm/bootstrap/utils.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

import {default as SharedForm} from '@ifabnpm/bootstrap/component/form.js';

// -------
// Private
// -------

/**
 * Automatisches Absenden des Eleternformulares bei Änderungen eines Formularelementes.
 * @param {Object} o
 * @returns Array
 */
const setupAutoSubmit = (o = {}) => {
	const _o         = extend({}, {
		timeout : 100
	}, o);
	const collection = SelectorEngine.find('[data-form-autosubmit]');

	if (collection.length) {
		for (const element of collection) {
			const form = SelectorEngine.parents(element, '.form');
			const type = element.getAttribute('type');

			let evName = (element.tagName.toLowerCase() === 'select') ? 'change' : '';

			if (!evName && type && ['radio', 'checkbox'].includes(type)) {
				evName = 'click';
			}

			if (evName && form[0]) {
				EventHandler.on(element, evName, () => {
					setTimeout(() => {
						HTMLFormElement.prototype.submit.call(form[0]);
						// form[0].submit();
					}, _o.timeout);
				});
			}
		}
	}

	return collection;
};

// ------
// Public
// ------

/**
 * Initialisierung.
 *
 * @param {Object} o
 * @returns Array
 */
const init = (o = {}) => {
	SharedForm.init();
	setupAutoSubmit();
};

// Export
export default {
	init: init
};
